import { render, staticRenderFns } from "./CognitiveColorTable.vue?vue&type=template&id=1b8617ca&scoped=true"
import script from "./CognitiveColorTable.vue?vue&type=script&lang=js"
export * from "./CognitiveColorTable.vue?vue&type=script&lang=js"
import style0 from "./CognitiveColorTable.vue?vue&type=style&index=0&id=1b8617ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8617ca",
  null
  
)

export default component.exports